<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-download"></i>
        WSFinder(Webshell) Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Dashboard</a>
        </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> WSFinder(Webshell) Dashboard
      </template> -->
        <b-row>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h1><strong>
                  <number ref="module_check_1" :from="0" :to="info && info.module ? info.module.alive + info.module.deleted : 0" :format="value_comma" :duration="2"/>
                  <sup style="font-size: 20px"> 설치</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>사용중 :
                  <number ref="module_check_2" :from="0" :to="info && info.module && info.module.alive > 0 ? info.module.alive : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>삭제됨 :
                  <number ref="module_check_3" :from="0" :to="info && info.module && info.module.deleted > 0 ? info.module.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>전체 :
                  <number ref="module_check_4" :from="0" :to="info && info.module && info.module.deleted > 0 ? info.module.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-success">
              <b-card-body class="pb-0" >
                <h1><strong>
                  <number ref="scan_check_1" :from="0" :to="info && info.day && info.day.scan_count > 0 ? info.day.scan_count : 0" :format="value_comma" :duration="2"/>
                  <sup style="font-size: 20px"> 점검</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>오늘 :
                  <number ref="scan_check_2" :from="0" :to="info && info.day && info.day.scan_count > 0 ? info.day.scan_count : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>최근 7일 :
                  <number ref="scan_check_3" :from="0" :to="info && info.week && info.week.scan_count > 0 ? info.week.scan_count : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>이번 달 :
                  <number ref="scan_check_4" :from="0" :to="info && info.month && info.month.scan_count > 0 ? info.month.scan_count : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h1><strong>
                  <number ref="detect_check_1" :from="0" :to="info && info.day && info.day.detect_count > 0 ? info.day.detect_count : 0" :format="value_comma" :duration="2"/>
                <sup style="font-size: 20px"> 탐지</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>오늘 :
                  <number ref="detect_check_2" :from="0" :to="info && info.day && info.day.detect_count > 0 ? info.day.detect_count : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>최근 7일 :
                  <number ref="detect_check_3" :from="0" :to="info && info.week && info.week.detect_count > 0 ? info.week.detect_count : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>이번 달 :
                  <number ref="detect_check_4" :from="0" :to="info && info.month && info.month.detect_count > 0 ? info.month.detect_count : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-warning">
              <b-card-body class="pb-0">
                <h1><strong>
                  <number ref="isolation_check_1" :from="0" :to="info && info.day && info.day.isolation_count > 0 ? info.day.isolation_count : 0" :format="value_comma" :duration="2"/>
                <sup style="font-size: 20px"> 격리</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>오늘 :
                  <number ref="isolation_check_2" :from="0" :to="info && info.day && info.day.isolation_count > 0 ? info.day.isolation_count : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>최근 7일 :
                  <number ref="isolation_check_3" :from="0" :to="info && info.week && info.week.isolation_count > 0 ? info.week.isolation_count : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>이번 달 :
                  <number ref="isolation_check_4" :from="0" :to="info && info.month && info.month.isolation_count > 0 ? info.month.isolation_count : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    <b-card ref="_ms">
      <b-row>
        <b-col class="title">
          에이전트 상태 (최대 표시 100)
          <b-button class="float-right btn-addition" size="m" variant='success' to="/downloads/">다운로드</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center" v-if="agents.length > 0">
        <b-col md="3" sm="3" xl="3" v-for="(item, index) in agents" :key="index" :ref="`_agent_${index}`">
          <b-card @click="detail(item)" :style="{ cursor: 'pointer'}">
            <b-badge class="btn-add" variant="success" v-if="!item.ms == 0 ">온라인</b-badge>
            <b-badge v-else>오프라인</b-badge>
            <p class="ml-2 font-weight-bold">{{item.name || '-'}}</p>
            <hr>
            <h6>{{item.ip_addr}}<br></h6>
            <b-badge variant="info">확인 : {{item.total_scan}}</b-badge>
            <br>
            <b-badge v-if="item.total_detect" variant="danger">탐지 : {{item.total_detect}}</b-badge>
            <!-- <i v-if="item.scanning" class="fa fa-refresh fa-spin"></i> -->
            <hr>
            <p>
              <b-spinner variant="warning" v-if="item && item.scanning" small type="grow"></b-spinner>
              <span :class="`font-weight-bold ml-1 ${item.scanning ? 'text-warning' : ''}`">
                {{item.scanning ? '점검중' : '대기중'}}
              </span>
            </p>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else style="text-align:center;">
        <b-col sm="6" lg="12">
          <b-card no-body class="bg-success">
            <b-card-body class="pb-20">
              <h3 class="mb-0">설치된 에이전트가 없습니다</h3>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <router-view ></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
